import axios from 'axios';

export async function checkInputData(formData) {
  let data = {};
  let errors = [];
  let favorite_sports = [];
  let favorite_brand = [];
  let has_child = [];
  data.id = customer.id;
  data.metafields = [];
  for (const [key, value] of formData) {
    console.log("🚀 ~ file: utils.js ~ line 7 ~ checkInputData ~ key", key)
    if (key === 'email') {
      if (typeof value === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        data.email = value;
      } else {
        errors.push('error_email');
      }
    } else if (key === 'first_name') {
      console.log("🚀 ~ file: utils.js ~ line 15 ~ checkInputData ~ firstname ~ value", value, typeof value)
      if (typeof value === 'string' && /^[a-zA-Z\s'-æøåäöëïÆØÅÄÖËÏ]+$/.test(value)) {
        data.firstName = value;
      } else {
        errors.push('error_name');
      }
    } else if (key === 'last_name') {
      console.log("🚀 ~ file: utils.js ~ line 22 ~ checkInputData ~ lastname ~ value", value, typeof value)
      if (typeof value === 'string' && /^[a-zA-Z\s'-æøåäöëïÆØÅÄÖËÏ]+$/.test(value)) {
        data.lastName = value;
      } else {
        errors.push('error_name');
      }
    } else if (key === 'phone') {
      if (typeof value === 'string' && /^\+?[1-9]\d{1,14}$/.test(value)) {
        data.phone = value;
      } else {
        errors.push('error_phone');
      }
    } else if (key === 'gender_search_input') {
      let gender;
      switch (value) {
        case 'Kvinde': gender = 'female'; break;
        case 'Mand': gender = 'male'; break;
        default: break;
      }
      if (gender) {
        const genderMetafieldData = { "key": "gender", "namespace": "custom", "value": gender };
        data.metafields.push(genderMetafieldData);
      }
    } else if (key === 'birth_date') {
      if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const birthdateMetafieldData = { "key": "birth_date", "namespace": "facts", "value": value };
        data.metafields.push(birthdateMetafieldData);
      } else {
        errors.push('error_birthdate');
      }
    }
    else if (key === 'store_search_input') {
      const storeMetafieldData = { "key": "favourite_intersport", "namespace": "custom", "value": value };
      data.metafields.push(storeMetafieldData);
    }
    else if (key === 'club_search_input') {
      const clubMetafieldData = { "key": "favourite_club", "namespace": "custom", "value": value };
      data.metafields.push(clubMetafieldData);
    }
    else if (key === 'sport_search_input[]') favorite_sports.push(value);
    else if (key === 'brand_search_input[]') favorite_brand.push(value);
    else if (key === 'children_status_search_input[]') has_child.push(value);
  }

  if (favorite_sports.length) {
    const favoriteSportsMetafieldData = { "key": "favourite_sport", "namespace": "custom", "value": favorite_sports.join(',') };
    data.metafields.push(favoriteSportsMetafieldData);
  }
  if (favorite_brand.length) {
    const favoriteBrandMetafieldData = { "key": "favourite_brand", "namespace": "custom", "value": favorite_brand.join(',') };
    data.metafields.push(favoriteBrandMetafieldData);
  }
  if (has_child.length) {
    const hasChildMetafieldData = { "key": "has_child", "namespace": "custom", "value": has_child.join(',') };
    data.metafields.push(hasChildMetafieldData);
  }
  console.log("🌞", { errors, data })
  return { errors, data };
}

export async function updateAccountDetails(data) {
  try {
    const url = `https://intersportapi.netlify.app/.netlify/functions/updateCustomer`;
    await axios.post(url, data);
    return true;
  } catch (error) {
    console.log('🚀 ~ error:', error);
    document.querySelector('[data-form-status="error"]')?.classList.remove('hidden');
    return false;
  }
}

export async function updateEmailMarketingConsent(data) {
  try {
    const url = `https://intersportapi.netlify.app/.netlify/functions/updateCustomerEmailMarketing`;
    await axios.post(url, data);
    console.log("success updateEmailMarketingConsent")
    return true;
  } catch (error) {
    console.log('🚀 ~ error:', error);
    document.querySelector('[data-form-status="error"]')?.classList.remove('hidden');
    return false;
  }
}

export async function updateSMSMarketingConsent(data) {
  try {
    const url = `https://intersportapi.netlify.app/.netlify/functions/updateCustomerSMSMarketing`;
    await axios.post(url, data);
    console.log("success updateSMSMarketingConsent")
    return true;
  } catch (error) {
    console.log('🚀 ~ error:', error);
    document.querySelector('[data-form-status="error"]')?.classList.remove('hidden');
    return false;
  }
}

export async function resetMessages() {
  document.querySelector('[data-form-status="success"]')?.classList.add('hidden');
  document.querySelector('[data-form-status="error"]')?.classList.add('hidden');
  document.querySelector('[data-form-status="error_email"]')?.classList.add('hidden');
  document.querySelector('[data-form-status="error_phone"]')?.classList.add('hidden');
}

export async function splitName(fullName) {
  const [firstName, ...lastName] = fullName.trim().split(/\s+/);
  const firstNameInput = document.querySelector('[data-first-name]');
  const lastNameInput = document.querySelector('[data-last-name]');
  if (firstNameInput) firstNameInput.value = firstName;
  if (lastNameInput) lastNameInput.value = lastName.join(' ');
}

export async function getInitialCustomerData(id) {
  return shopifyCustomer = await axios.get(`https://intersportapi.netlify.app/.netlify/functions/getCustomer?id=${id}`);
}